import { Component, inject } from '@angular/core';
import {FinishBoxComponent} from "../../../common/finish-box/finish-box.component";
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import {NgOptimizedImage} from "@angular/common";
import {RouterLink} from "@angular/router";
import {LocaleService} from "../../../../locale/locale.service";
import { ColoredBackgroundComponent } from '../../../common/colored-background/colored-background.component';

@Component({
  selector: 'app-importance-of-quick-response',
  imports: [
    ColoredBackgroundComponent,
    FinishBoxComponent,
    FooterComponent,
    HeaderComponent,
    RouterLink
  ],
  templateUrl: './importance-of-quick-response.component.html',
  styleUrl: './importance-of-quick-response.component.css'
})
export class ImportanceOfQuickResponseComponent {
  locale = inject(LocaleService);
}
